import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import * as CopyText from '@segment/matcha/recipes/CopyText'

import { trackButtonClick } from '@segment/tracking/scripts'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Pricing that scales`,
  description: `Find the right plan and add-ons to enable your engineering, marketing, and product teams to power adaptive, personalized customer experiences with good data.`,
}

const button = {
  text: `Get a demo`,
  url: `/demo/`,
}

const Hero: FC<PropsWithChildren> = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledHeroBase variant="centered">
        <HeroRecipe.Copy>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Contents>
            <StyledButton
              size="medium"
              variant="filled"
              color="primary"
              href={getAbsoluteUrl(button.url, pageConfig)}
              onClick={() =>
                trackButtonClick({
                  buttonText: button.text,
                  targetUrl: button.url,
                  buttonId: `pricing-landing-page-hero-demo`,
                })
              }
            >
              {button.text}
            </StyledButton>
          </HeroRecipe.Contents>
        </HeroRecipe.Copy>
      </StyledHeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.mint[10]};
`
const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    padding-bottom: 0px;
    gap: 0;
  }
`

const StyledButton = styled(Button)`
  margin-top: 24px;

  ${({ theme }) => theme.breakpoints.down(`md`)} {
    margin-top: 0;
  }
`

export default Hero
